<template>
    <AjaxVueSelectFilter
        :url="url"
        :initial-value="initialValue"
        @search="(legislations) => $emit('selected', legislations)"
    />
</template>

<script>
import {AjaxVueSelectFilter} from "@core/components/common/filter/index";
import ApiRoutes from "@core/api/route"

export default {
    components: {AjaxVueSelectFilter},
    props: {
        initialValue: {
            default() {
                return [];
            }
        }
    },
    data() {
        return {
            url: ApiRoutes.legislation.all()
        };
    }
}
</script>
